import { Check, HelpCircle, TriangleAlert, X } from "lucide-react";

const MAP = {
  meets: { label: "Meets Requirement", cls: "bg-[#e9f5f2] text-[#13795B] border-[#bfe0d8]", Icon: Check },
  deviation: { label: "Technical Deviation", cls: "bg-[#fff4df] text-[#B7791F] border-[#f0dcb4]", Icon: TriangleAlert },
  fails: { label: "Does Not Meet Requirement", cls: "bg-[#fdecec] text-[#B42318] border-[#f4c9c6]", Icon: X },
  unknown: { label: "Not Specified", cls: "bg-[#eef1f5] text-[#667788] border-[#DFE6ED]", Icon: HelpCircle },
};

export const AvailabilityChip = ({ quote, testId }) => {
  const map = {
    ex_stock: { label: "Ex-stock", cls: "bg-[#e9f5f2] text-[#13795B] border-[#bfe0d8]" },
    partial: { label: "Partially ex-stock", cls: "bg-[#fff4df] text-[#B7791F] border-[#f0dcb4]" },
    to_order: { label: "Made to order", cls: "bg-white/[0.06] text-[#b9c4d4] border-white/15" },
  };
  const key = quote?.availability || "to_order";
  const { label, cls } = map[key] || map.to_order;
  const where = [quote?.stock_location, quote?.stock_country].filter(Boolean).join(", ");
  return (
    <span data-testid={testId || `availability-chip-${key}`}
      className={`inline-flex flex-col items-start gap-0.5 rounded-[10px] border px-2.5 py-1.5 text-xs font-semibold ${cls}`}>
      <span>{label}{key === "partial" && quote?.stock_quantity ? ` · ${quote.stock_quantity} pcs` : ""}</span>
      {key !== "to_order" && where && <span className="font-normal">in {where}</span>}
    </span>
  );
};

export const StockBadge = ({ status, location, testId }) => {
  const map = {
    in_stock: { label: "In stock", cls: "bg-[#e9f5f2] text-[#13795B] border-[#bfe0d8]" },
    low_stock: { label: "Low stock", cls: "bg-[#fff4df] text-[#B7791F] border-[#f0dcb4]" },
    out_of_stock: { label: "Out of stock", cls: "bg-[#fdecec] text-[#B42318] border-[#f4c9c6]" },
  };
  const entry = map[status];
  if (!entry) return <span className="text-xs text-[#8598ac]">—</span>;
  return (
    <span data-testid={testId || `stock-badge-${status}`}
      className={`inline-flex flex-col items-start gap-0.5 rounded-[10px] border px-2.5 py-1 text-xs font-semibold ${entry.cls}`}>
      <span>{entry.label}</span>
      {location && <span className="font-normal">{location}</span>}
    </span>
  );
};

export const StatusChip = ({ status, compact = false, testId }) => {
  const { label, cls, Icon } = MAP[status] || MAP.unknown;
  return (
    <span
      data-testid={testId || `conformity-status-chip-${status}`}
      title={label}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${cls}`}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={3} />
      {compact ? null : label}
    </span>
  );
};

export const StatusLegend = () => (
  <div className="flex flex-wrap items-center gap-3" data-testid="conformity-legend">
    <StatusChip status="meets" testId="legend-meets" />
    <StatusChip status="deviation" testId="legend-deviation" />
    <StatusChip status="fails" testId="legend-fails" />
  </div>
);

export const MandatoryTag = ({ mandatory }) => (
  <span
    className={`ml-1.5 rounded px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-[0.08em] ${
      mandatory ? "bg-[#102A43] text-white" : "bg-[#eef1f5] text-[#667788]"
    }`}
  >
    {mandatory ? "Mandatory" : "Optional"}
  </span>
);
